export default __webpack_public_path__ + "static/media/bg-image.4659bba3.jpg";